import axios from 'axios';

const CancelToken = axios.CancelToken;

const getCancelSource = () => CancelToken.source();

export default getCancelSource;
